/*global jQuery*/
(function (factory) {
	'use strict';
	if (typeof define === 'function' && define.amd) {
		define('all/lazyloader',['jquery'], factory);
	} else {
		factory(jQuery);
	}
}(function ($) {
	'use strict';

	$.fn.lazyLoadSrc = function () {
		this.each(function () {
			$(this).find('img[data-src]:not(template img), script[data-src]:not(template script)').each(function() {
				$(this).attr('src', $(this).data('src'));
			});
		});
		return this;
	};
	// For AUSTRALIA, with LOVE
	// load images and scripts after onload, any unimportant image/script can be lazy-loaded by doing:
	// src="" data-src="actual URL"
	$(function() {
		$(document).lazyLoadSrc();
	});
}));

